import {Box, Flex, Image} from '@chakra-ui/react'
import {PropsWithChildren} from 'react'
import {HalfImageLayout, HalfImageLayoutProps} from '../../layout'
import {AuthFooter} from './footer'
import {AuthHeader} from './header'

interface Props extends PropsWithChildren {
  image?: HalfImageLayoutProps['image']
}

export function AuthLayout({image, children}: Props) {
  return (
    <Box padding="1" background="bg.muted" width="100%" height="100dvh">
      <HalfImageLayout image={image}>
        <Image
          src="/static/login-background.webp"
          alt="Background"
          role="presentation"
          position="absolute"
          top="0"
          left="0"
          pointerEvents="none"
          zIndex="1"
          width="100vw"
          height="auto"
        />

        <Flex flexDirection="column" justifyContent="space-between" height="100%" position="relative" zIndex="5">
          <AuthHeader />
          <main>{children}</main>
          <AuthFooter />
        </Flex>
      </HalfImageLayout>
    </Box>
  )
}
